import { useCallback, useMemo } from 'react';
import { useCurrentUserProfile } from 'src/graphql/entities/platform-user';
import {
  TimeFormats,
  useCreateUserSettingValue,
  UserSettingId,
  useUpdateUserSettingValue,
} from 'src/graphql/entities/user-setting-value';

export function useTimeFormat() {
  const { user } = useCurrentUserProfile();

  const currentTimeFormat = useMemo(
    () => user?.userSettingValueMap.get(UserSettingId.TimeFormatPreference),
    [user?.userSettingValueMap],
  );

  const { createUserSettingValue } = useCreateUserSettingValue();
  const { updateUserSettingValue } = useUpdateUserSettingValue();

  const changeTimeFormat = useCallback(
    (timeFormat: TimeFormats) => {
      if (currentTimeFormat) {
        updateUserSettingValue(currentTimeFormat.userSettingValue, {
          value: timeFormat,
        });
      } else {
        createUserSettingValue({
          userSettingId: UserSettingId.TimeFormatPreference,
          value: timeFormat,
          valueType: 'string',
        });
      }
    },
    [createUserSettingValue, currentTimeFormat, updateUserSettingValue],
  );

  return useMemo(
    () => ({
      changeTimeFormat,
      currentTimeFormat: (currentTimeFormat?.value as TimeFormats) || TimeFormats.Auto,
    }),
    [changeTimeFormat, currentTimeFormat?.value],
  );
}
